import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  { name: "Sarah M.", location: "Homeowner", stars: 5, text: "JD installed air con in three of our bedrooms and the living room. Spotless work, turned up on time and the quote was exactly what we paid. Couldn't recommend them more." },
  { name: "David R.", location: "Landlord", stars: 5, text: "Used JD for EICR testing and a fuse board upgrade across two rental properties. Professional, certified and genuinely helpful advice. My go-to electrician now." },
  { name: "Emma T.", location: "Homeowner", stars: 5, text: "Had our whole house rewired and new LED lighting throughout. Tidy, respectful and explained everything clearly. The finish is brilliant." },
  { name: "Mark P.", location: "Business owner", stars: 5, text: "Fast response when our air con packed in during a heatwave. Diagnosed and repaired same day. Fair price and a proper professional job." },
  { name: "Laura B.", location: "Homeowner", stars: 5, text: "From the first message to the finished EV charger install, everything was smooth. Really friendly and clearly knows their stuff." },
];

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} className={i < n ? "fill-brand-yellow text-brand-yellow" : "text-black/15"} />
    ))}
  </div>
);

export const Reviews = () => {
  return (
    <section id="reviews" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-brand-yellow mb-4">
              Reviews
            </p>
            <h2 className="font-display font-extrabold tracking-tighter text-ink text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
              What our customers say.
            </h2>
          </div>
          <div className="flex items-center gap-4 rounded-2xl border border-black/10 bg-white px-6 py-4">
            <span className="font-display text-5xl font-extrabold tracking-tighter text-ink">5.0</span>
            <div>
              <Stars n={5} />
              <p className="font-body text-sm text-ink/55 mt-1">Rated by local homeowners</p>
            </div>
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {reviews.map((r, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              data-testid={`review-card-${i}`}
              className="mb-5 break-inside-avoid rounded-2xl border border-black/10 bg-white p-7 hover:border-brand-yellow transition-colors duration-300"
            >
              <Quote size={28} className="text-brand-yellow mb-4" />
              <blockquote className="font-body text-lg text-ink/80 leading-relaxed">"{r.text}"</blockquote>
              <figcaption className="mt-6 flex items-center justify-between border-t border-black/5 pt-5">
                <div>
                  <p className="font-display font-bold text-ink">{r.name}</p>
                  <p className="font-body text-sm text-ink/50">{r.location}</p>
                </div>
                <Stars n={r.stars} />
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
